import {Datagrid, DateField, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {initField} from "../../shared/utils";
import {IdentifierField} from "../../components/IdentifierField";

export const DocumentDatagrid = ({ options, ...rest }: DatagridPropsWithOptions) => {
  return options ? (
    <Datagrid>
      <IdentifierField {...initField("id", options)} />
      <TextField {...initField("category_document_obj.name", options)} label="Documento"/>
      <TextField {...initField("amount", options)}/>
      <DateField {...initField("expiration_date", options)} />
      <DateField {...initField("invoice_date", options)} label="Data documento"/>
      <TextField {...initField("notes", options)} />
    </Datagrid>
  ) : null
};


